import graphql__2d560573ef80778ffa38 from "./__generated__/ProfileSettingsRouteQuery.graphql.js";import { Component } from "react";
import { graphql } from "react-relay";
import AppQueryRenderer from "../AppQueryRenderer";

import AuthenticationWall from "../Authentication/AuthenticationWall";
import ProfileSettings from "../Profile/ProfileSettings";

class ProfileSettingsRoute extends Component {
  render() {
    return (
      <AuthenticationWall>
        <AppQueryRenderer
          query={ProfileSettingsRouteQuery}
          component={ProfileSettings}
          additionalProps={this.props}
        />
      </AuthenticationWall>
    );
  }
}

const ProfileSettingsRouteQuery = graphql__2d560573ef80778ffa38;

export default ProfileSettingsRoute;
